import React, { useLayoutEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './CreativePreferences.css';
import { useBootstrapPreview } from './state/usePreferences';
import { CreativePreferencesStore } from './state/store';
import Shell from './Shell';

/**
 * Ops read a form version the way a client sees it, before publishing.
 * Opened from the Preference Config Panel. There is no booking and no brief
 * behind the page, so the controls work but nothing is saved anywhere.
 */
const CreativeFormPreviewPage = ({
  chrome,
  useStoreToken,
  navSelector,

}) => {
  const [params] = useSearchParams();
  const version = params.get('version') || '';
  const {
    storeToLocal
  } = useStoreToken();

  // Must run before the fetch below: it moves ?token= into localStorage and
  // strips it from the address bar, so the staff token is not left copyable.
  useLayoutEffect(() => {
    storeToLocal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    error,
    versionState
  } = useBootstrapPreview({
    version
  });
  const banner = React.createElement("div", {
    className: "cp-savewarn is-info"
  }, "Preview of version ", version, versionState ? ` (${versionState})` : '', ". Nothing here is saved.");
  return React.createElement(React.Fragment, null, chrome, error ? React.createElement("div", {
    className: "cp-loading"
  }, error.message || 'This preview link is not valid.') : React.createElement(Shell, {
    banner: banner,
    navSelector: navSelector
  }));
};
const CreativeFormPreview = props => React.createElement(CreativePreferencesStore, null, React.createElement(CreativeFormPreviewPage, {
  ...props
}));
export default CreativeFormPreview;
